import { Job } from './job';
import { Company } from '../company/companyprofile';

export class JobReferralWrapper {

    public status: boolean = false;
    public errorMessageKey: string = '';
    public referralEventType: string = '';
    public referredUserName: string = '';
    public referralEventDescription: string = '';
    public referralCode: string = '';
    public jobInfo: Job = new Job();
    public companyInfo: Company = new Company();

}
